import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { Observable } from 'rxjs';
import { GeneralAdminStore, GState } from './general-admin.store';
import { OrganisationDto } from '../../core/models/organisation-dto';
import { UnitOfMeasureDto } from '../../core/models/unit-of-measure-dto';

@Injectable({ providedIn: 'root' })
export class GeneralAdminQuery extends QueryEntity<GState> {
  loading$ = this.selectLoading();
  organisations$: Observable<OrganisationDto[]> = this.select('organisations');
  unitOfMeasure$: Observable<UnitOfMeasureDto[]> = this.select('unitOfMeasure');
  currencies$: Observable<string[]> = this.select('currencies');

  constructor(protected store: GeneralAdminStore) {
    super(store);
  }
}
